import { LANGUAGE } from "src/app/shared/constants/common.const";
import { Util } from "src/app/shared/helpers/util";

export class ReqHeader {
  public previousTransactionId = 0;
  public previousTransactionDate = '';
  public userID = '';
  public customerNo = '';
  public languageCode = '';

  constructor() {
    const util = new Util();
    const userLoginData = util.getSecureStorage('USER_INFO');
    this.languageCode = LANGUAGE[util.getSecureStorage('langCode') || 'en'];
    if (userLoginData) {
      this.userID = userLoginData.userID;
      this.customerNo = userLoginData.customerNo;
    }
  }
}
